export default "__VITE_ASSET__BOd3dtyr__";